import React, { useEffect } from "react";
import { useAssets } from "../reactQuery/domainAssets";
import { getAPIBaseUrl } from "../utils/constants";
 
const DynamicHeadAssets = () => {
  const { icon, logo } = useAssets();
  const apiUrl = getAPIBaseUrl();
 
  const favIcon = icon ? `${apiUrl}/${icon}` : null;
  const ogImage = logo ? `${apiUrl}/${logo}` : null;
 
  useEffect(() => {
    // Function to update or insert <link rel="icon">
    const updateFavicon = (iconUrl) => {
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = iconUrl;
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = iconUrl;
        document.head.appendChild(newLink);
      }
    };
 
    // Function to update or insert <meta property="og:image">
    const updateOgImage = (imageUrl) => {
      let metaTag = document.querySelector("meta[property='og:image']");
      if (metaTag) {
        metaTag.setAttribute("content", imageUrl);
      } else {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("property", "og:image");
        metaTag.setAttribute("content", imageUrl);
        document.head.appendChild(metaTag);
      }
    };
 
    if (favIcon) updateFavicon(favIcon);
    if (ogImage) updateOgImage(ogImage);
  }, [favIcon, ogImage]);
 
  return null; // This component does not render UI
};
 
export default DynamicHeadAssets;